/* istanbul ignore file */
import { useCallback } from 'react';
import { useFieldHelper } from 'framework/ui/field';
import { useAuthorization } from 'framework/authorization';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import { ModalFormButton, FormFieldsData } from 'framework/form';
import { EmployeeExpertise, UpdateExpertiseDto } from 'domain/people/employee/expertise/service/expertiseService.types';
import { useIsMyProfile } from 'domain/shared/employee';
import useExpertiseService from 'domain/people/employee/expertise/service/expertiseService';
import { ExpertisePermission } from 'domain/people/employee/expertise/service/expertiseService.model';
import expertiseValidationSchema from '../add/expertiseValidationSchema';
import AddExpertiseForm from '../add/AddExpertiseForm';

const EditExpertiseAction = () => {
  const isMyProfile = useIsMyProfile();
  const { updateEmployeeExpertise } = useExpertiseService();
  const { isGranted } = useAuthorization();
  const { getData } = useFieldHelper();
  const data = getData() as EmployeeExpertise;

  const submitFormFunc = useCallback(
    ({ experienceDuration, expertiseType, level, comment }: FormFieldsData) => {
      const item: UpdateExpertiseDto = {
        employeeExpertiseId: data.id,
        experienceDuration,
        expertiseType,
        level,
        comment,
      };
      return updateEmployeeExpertise(item);
    },
    [updateEmployeeExpertise, data.id],
  );

  if (!isGranted(ExpertisePermission.PEOPLE_MANAGEMENT_EMPLOYEE_EXPERTISE_UPDATE) || isMyProfile) {
    return null;
  }

  return (
    <ModalFormButton
      formTitle={`Edit expertise ${data.expertise.displayName}`}
      getValidationSchemaFunc={async () => expertiseValidationSchema}
      color="transparent"
      label={<AppRegistrationIcon color="primary" />}
      submitFormFunc={submitFormFunc}
      paperStyles={{
        background: 'var(--mui-palette-background-paper)',
      }}
      sxButton={{
        minWidth: 'auto',
        p: 0,
      }}
      initialData={{
        expertiseId: data.id,
        experienceDuration: data.experienceDuration,
        expertiseType: data.expertiseType,
        level: data.level,
        comment: data.comment,
      }}
    >
      <AddExpertiseForm isEdit={true} />
    </ModalFormButton>
  );
};

export default EditExpertiseAction;
